<template>
    <console-layout width="100%" max-width="1024">

        <console-title>뷰어 설정</console-title>

        <console-search @search="page = 1; search(true);">
            <v-row align="center">
                <v-col cols="12" sm="4">
                    <v-select v-model="filter.searchKey" :items="searchKeys" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;"></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true);"></v-text-field>
                </v-col>
            </v-row>
        </console-search>

        <console-body>
            <v-data-table :items="viewers" :headers="viewersHeaders" hide-default-footer disable-sort class="elevation-1">
                <template #[`item.actions`]="{item}">
                    <v-icon small @click="edit(item)">mdi-pencil</v-icon>
                    <v-icon small class="ml-1" @click="remove(item)">mdi-delete</v-icon>
                </template>
                <template #[`item.createdAt`]="{item}">
                    {{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>
        </console-body>

        <v-btn v-if="$hasScope(['root', 'admin'])" color="accent" fab fixed bottom right dark @click="create"><v-icon>mdi-pencil</v-icon></v-btn>

    </console-layout>
</template>

<script>
import XLSX from "xlsx";
import api from "@/api";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "업체명", value: "companyName" },
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            viewers: [],
            viewersHeaders: [
                { text: "아이디", value: "username", align: "center" },
                { text: "이름(담당자)", value: "name", align: "center" },
                { text: "연락처(담당자)", value: "phone", align: "center" },
                { text: "이메일(담당자)", value: "email", align: "center" },
                { text: "추천인코드", value: "refid", align: "center" },
                { text: "생성일자", value: "createdAt", align: "center", width: 200 },
                ...(this.$hasScope(['root', 'admin']) ? [{ text: "actions", value: "actions", align: "center", width: 100 }] : []),
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();
        },

        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, viewers } = await api.console.user.viewers.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.viewers = viewers;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        create(){
            this.$router.push(`/console/user/viewers/create`);
        },

        edit(viewer){
            this.$router.push(`/console/user/viewers/${viewer._id}`);
        },

        async remove(viewer){
            if(confirm("정말 삭제하시겠습니까?")){
                await api.console.user.viewers.delete(viewer);
                alert("삭제되었습니다");
                this.search();
            }
        },

        async excel(){
            let { viewers } = await api.console.user.viewers.gets({
                headers: { limit: 0 },
                params: this.filter
            });

            var datas = [];
            viewers.forEach(viewer => {
                datas.push({
                    "아이디": viewer?.username,
                    "연락처": viewer?.phone,
                    "이메일": viewer?.email,
                    "생성일자": viewer?.createdAt ? this.$dayjs(viewer?.createdAt).format("YYYY-MM-DD HH:mm:ss") : "-"
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(datas);

            XLSX.utils.book_append_sheet(workbook, worksheet, "제휴업체 목록");
            XLSX.writeFile(workbook, "제휴업체 목록.xlsx");
        }
    }
}
</script>